export default "__VITE_ASSET__C32vPVWO__"